import React from 'react';
import { useTranslation } from 'react-i18next';
import { DriftIcons } from 'drift-ui';
import styles from './PdfErrorPanel.scss';

const { WarningIcon } = DriftIcons;

type PdfErrorPanelProps = {
  onRefresh: () => void;
};

const PdfErrorPanel: React.FC<PdfErrorPanelProps> = ({ onRefresh }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.pdfErrorContainer}>
      <div className={styles.pdfErrorContent}>
        <WarningIcon color="error" />
        <p className={styles.pdfErrorMessage}>
          {t('digital_onboarding.banking.error_displaying_document')}
          <br />
          {t('digital_onboarding.banking.refresh_to_continue')}
        </p>
      </div>
      <button type="button" className={styles.refreshButton} onClick={onRefresh}>
        {t('digital_onboarding.banking.refresh')}
      </button>
    </div>
  );
};

export default PdfErrorPanel;
